module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "chat.9aae76f3.svg";